import React from "react";

import EventCreated from "./preview/EventCreated";
import UserClaimed from "./preview/UserClaimed";
import WidgetSurveyActivated from "./preview/WidgetSurveyActivated";
import AnnouncementCreated from "./preview/AnnouncementCreated";
import AnnouncementUpdated from "./preview/AnnouncementUpdated";
import OrganizationValueCreated from "./preview/OrganizationValueCreated";
import PhotoCreated from "./preview/PhotoCreated";
import PostCreated from "./preview/PostCreated";
import Story from "./preview/Story";
import ApprovedForSocial from "./preview/ApprovedForSocial";
import SocialSharePreview from "./preview/SocialSharePreview";
import ExternalSocialSharePreview from "./preview/ExternalSocialSharePreview";

const Preview = ({
  item,
  onPhotoCheerToggle,
  onStoryCheerToggle,
  onSurveyComplete,
  onUserActivityUpdate,
  onUserActivityRemove
}) => {
  switch (item.activityType) {
    case "event_created":
      return (
        <EventCreated
          item={item}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    case "user_claimed":
      return (
        <UserClaimed
          item={item}
          onUserActivityUpdate={onUserActivityUpdate}
        />
      );
    case "widget_survey_activated":
      return (
        <WidgetSurveyActivated
          item={item}
          onSurveyComplete={onSurveyComplete}
          onUserActivityUpdate={onUserActivityUpdate}
        />
      );
    case "announcement_created":
      return (
        <AnnouncementCreated
          item={item}
          onUserActivityUpdate={onUserActivityUpdate}
        />
      );
    case "announcement_updated":
      return <AnnouncementUpdated item={item} />;
    case "organization_value_created":
      return <OrganizationValueCreated item={item} />;
    case "photo_created":
      return (
        <PhotoCreated
          item={item}
          onPhotoCheerToggle={onPhotoCheerToggle}
          onUserActivityUpdate={onUserActivityUpdate}
        />
      );
    case "post_created":
      return (
        <PostCreated
          userActivity={item}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    case "story_created":
      return (
        <Story
          userActivity={item}
          onStoryCheerToggle={onStoryCheerToggle}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    case "approved_for_social":
      return (
        <ApprovedForSocial
          userActivity={item}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    case "social_share":
      return (
        <SocialSharePreview
          userActivity={item}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    case "external_social_share":
      return (
        <ExternalSocialSharePreview
          userActivity={item}
          onUserActivityUpdate={onUserActivityUpdate}
          onUserActivityRemove={onUserActivityRemove}
        />
      );
    default:
      return null;
  }
};

export default Preview;
